// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__31os7","fileDisabled":"File_fileDisabled__3gRYK"};